export default __webpack_public_path__ + "static/media/2001.bbbfa415.png";